import React from 'react';
import styled, { css } from 'styled-components';
import { Kode } from '../../Map/util/koder';
import { common } from '../../../style';
import { neutral } from '../../../style/colors';

const FilterListItem = (props: FilterListItemPropTypes) => {
  const { kode, toggled, onClick, backgroundColor } = props;

  return (
    <Wrapper
      toggled={toggled}
      title={kode.beskrivelse}
      onClick={() => {
        onClick(kode.kode);
      }}
    >
      <IconWrapper backgroundColor={backgroundColor} toggled={toggled} />
      <Text>{kode.tekst}</Text>
    </Wrapper>
  );
};

interface FilterListItemPropTypes {
  kode: Kode;
  toggled: boolean;
  onClick: Function;
  backgroundColor: string;
}
export default FilterListItem;

const Wrapper = styled.div`
  padding: 13px 20px;
  height: 54px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: 0.3s;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  border-bottom: 1px solid ${neutral[150]};
  font-family: ${common.fontFamily};
  ${props =>
    !props.toggled &&
    css`
      color: ${neutral[400]};
    `};
  ${props =>
    props.toggled &&
    css`
      background-color: #ffffff;
    `};
  &:hover {
    background-color: ${neutral[100]};
    color: ${neutral[700]};
  }
`;

const IconWrapper = styled.div`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 100%;
  ${props =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `};
  ${props =>
    !props.toggled &&
    css`
      background-color: #e0e7ee;
    `};
`;

const Text = styled.div`
  padding-left: 10px;
`;
